export const noDataDropdownOptions = [{ id: 0, value: 'No data' }];

export const phoneRegExp = /^0[1-9]\d{9}$|^[1-9]\d{9}$/;

/** Positive integer regex (1, 2, ... no leading zero) */
export const positiveNumber = /^[1-9]\d*$/;

export const CATEGORY_OPTIONS = {
	'End User Management': [
		'KYC Related',
		'Club Mapping',
		'Enrollment Related Error',
		'Invalid Contractor No',
		'User Not Showing',
		'User Transfer',
	],
	'Login Issue': ['Browser Cache', 'Login Issue', 'OTP Related', 'Profile Update Issue', 'User Deactivated'],
	'Mapping Issue': [
		'Dealer DropDown Issue',
		'Division DropDown Issue',
		'End User Related',
		'Hierarchy Master Issue',
		'Primary Dealer Issue',
		'Product Issue',
		'Site Not Reflecting',
		'Site Option Not Showing',
		'TTY Issue',
	],
	'Meeting Related': [
		'Attendance Not Captured',
		'Attendee KYC',
		'Invitation SMS Related',
		'Meeting Related',
		'Meeting Creation Related',
		'Meeting Not Reflecting',
		'Missed Call Related',
		'Speca Related Issue',
		'Virtual Meet Related',
	],
	'One to One Visit Related': ['One to One Error'],
	'RBDM mPower Related': ['CMDI Codes Not Visible', 'RBDM Login Issue', 'WSS TTY BM Issue'],
	'Site Related': ['Location Related', 'Other Related', 'Site Creation Error', 'Site Leads Issue', 'Site Visit Issue'],
	Other: [
		'Points Related',
		'BDE Dashboard Related',
		'End User Blocked Related',
		'FME Dashboard',
		'Interface Dashboard Related',
		'Knowledge Query',
		'Linkage Issue',
		'Other Apps Related',
		'PCMS',
		'Product DropDown Issue',
		'Product Related',
		'Reports or Salesforce Related',
		'Scorecard Related',
	],
};

export const DIVISION_CODES = ['WWA', 'CC', 'ROFF/ART', 'EI', 'MNT', 'FC', 'SET', 'FNB', 'FFF', 'BST', 'ASF', 'INO'];

export const OTHERS_SPECIFY = 'Others';

export const maxFileSize = 5 * 1024 * 1024;

export const POINTS_BANKED_OPTIONS = {
	min: 0,
	max: 10000,
	default: 0,
};

export const PAGE_SIZE = 100;

export const INFLUENCER_PROFILE_CATEGORIES = ['A0003']; // Engineers, Architect (design+ supervision), Repair consultant

export const BUILDER_PROFILE_CATEGORIES = ['A0005']; // Builder

export const WATERPROOFER_PROFILE_CATEGORIES = [
	'A0004', // Waterproofing Applicator - IHB // Waterproofing Applicator - MDU
];

export const MISTRY_PROFILE_CATEGORIES = [
	'A0010', // Raj Mistry/ Head Mason
];

export const CONTRACTOR_PROFILE_CATEGORIES = [
	'A0001', // Kothi Contractor
	'A0002', // Large Kothi Contractor
	'A0006', // Civil Contractor (8000 - 50,000 sqft)
];

export const LARGE_CONTRACTOR_PROFILE_CATEGORIES = [
	'A0002', // Large Kothi Contractor
	'A0006', // Civil Contractor (50,000 sqft - 100,000 sqft)
];

export const PAINTING_CONTRACTOR_PROFILE_CATEGORIES = ['A0007', 'A0008', 'A0009', 'A0011']; // Painting Contractor, Large Painting Contractor, Painter, Plumbing contractor

export const NON_END_USER_CATEGORIES = ['A0012']; // Non End User, Site Supervisor, Technician, Site Engineer, Purchase Manager, Project Manager

export const CALENDAR_HEADER = [
	{ id: 0, name: 'Day', value: 'day', icon: 'icon-sun' },
	{ id: 1, name: 'Week', value: 'week', icon: 'icon-sun' },
	{ id: 2, name: 'Month', value: 'month', icon: 'icon-sun' },
];

export const VALID_FILE_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];

//export const DROPDOWN_EXPIRY_MS = 1000 * 60 * 60 * 24 * 3; // 3 days
export const DROPDOWN_EXPIRY_MS = 1000 * 60 * 5; // 5 min for local testing purposes

export const CASE_STATUS_OPTIONS = [
	{ value: 'New Lead', label: 'New Case' },
	{ value: 'Site Visited', label: 'Case Visited' },
	{ value: 'Quotation issued', label: 'Quotation Issued' },
	{ value: 'Work in progress', label: 'Work in progress' },
	{ value: 'Work completed', label: 'Work Completed' },
	{ value: 'Order Lost', label: 'Order Lost' },
];

export const POLL_MS = 4000;

export const MAX_ATTEMPTS = 120;

export const IMAGE_FILE_TYPES = ['image/jpeg', 'image/png', 'image/jpg'];

export const DROPDOWN_NAMES = [
	{
		id: '1',
		name: 'end_user_categories',
	},
	{
		id: '2',
		name: 'dealer_list',
	},
	{
		id: '3',
		name: 'product_list',
	},
	{
		id: '4',
		name: 'town_list',
	},
	{
		id: '5',
		name: 'venue_list',
	},
	{
		id: '6',
		name: 'surface_list',
	},
	{
		id: '7',
		name: 'type_of_construction_list',
	},
	{
		id: '8',
		name: 'project_classification_list',
	},
	{
		id: '9',
		name: 'stage_of_construction_list',
	},
	{
		id: '10',
		name: 'source_of_site_lead_list',
	},
	{
		id: '11',
		name: 'module_name_list',
	},
	{
		id: '12',
		name: 'meeting_type_list',
	},
	{
		id: '13',
		name: 'btl_objective_list',
	},
	{
		id: '14',
		name: 'product_master_list',
	},
	{
		id: '15',
		name: 'cc_town_list',
	},
];

/** Strips leading whitespace from input (e.g. venue free-text). */
export const leadingWhitespaceRegExp = /^\s+/g;
